<script lang="ts">
  import IconStar from '~icons/tabler/star';
  import IconStarFilled from '~icons/tabler/star-filled';

  export let auctionId: number;
  export let isFavorite: boolean;
  export let variant: 'icon' | 'full' = 'icon';
  export let onClick = () => {};
  export let disabled = false;

  $: baseUrl = `/auctions/${auctionId}`;

  async function favorite() {
    isFavorite = true;

    const handleError = () => {
      isFavorite = false;
      alert('Something went wrong. Please try again later.');
    };

    try {
      const res = await fetch(`${baseUrl}/favorite`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!res.ok) {
        handleError();
      }
    } catch (err) {
      handleError();
    }
  }

  async function unfavorite() {
    isFavorite = false;

    const handleError = () => {
      isFavorite = true;
      alert('Something went wrong. Please try again later.');
    };

    try {
      const res = await fetch(`${baseUrl}/unfavorite`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        }
      });

      if (!res.ok) {
        handleError();
      }
    } catch (err) {
      handleError();
    }
  }

  function handleClick(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    onClick();

    if (isFavorite) {
      unfavorite();
    } else {
      favorite();
    }
  }
</script>

<button
  class="hstack align-items-center gap-2"
  class:btn={variant === 'full'}
  class:btn-sm={variant === 'full'}
  class:disabled
  class:full={variant === 'full'}
  on:click={handleClick}
>
  {#if isFavorite}
    <IconStarFilled style="color: var(--bs-yellow)" />
  {:else}
    <IconStar />
  {/if}

  {#if variant === 'full'}
    <span>
      {#if isFavorite}
        Added to favorites
      {:else}
        Add to favorites
      {/if}
    </span>
  {/if}
</button>

<style>
  button {
    z-index: 10;
  }

  button.full {
    border: 1px solid var(--bs-gray-300);
    color: var(--bs-gray-800);
  }

  button.full:hover {
    background: var(--bs-gray-100);
  }

  button:not(.full):hover {
    color: var(--bs-yellow);
  }
</style>
